@if (status) {
  <div
    class="processing-status"
    [class]="statusClass"
    [class.compact]="compact"
    (click)="$event.stopPropagation()"
  >

    <div
      class="tooltip-wrapper"
      [matTooltip]="tooltipText"
      matTooltipClass="processing-status-tooltip"
    >
      <!-- Status Icon -->
      <div class="status-icon-wrapper">
        @if (isProcessing && !hasError) { <mat-progress-spinner class="status-spinner" [diameter]="compact ? 16 : 20" mode="indeterminate"></mat-progress-spinner> }
        @else { <mat-icon class="status-icon">{{ icon }}</mat-icon> }
      </div>
      <!-- Label -->
      @if (showLabel) { <span class="status-label">{{ label }}</span> }
    </div>

    <!-- Progress Bar (hidden in compact mode) -->
    @if (showProgressBar && isProcessing && !hasError && !compact) {
      <div class="progress-wrapper">
        <mat-progress-bar mode="determinate" [value]="progress" color="accent"></mat-progress-bar>
        <span class="progress-text">{{ progress }}%</span>
      </div>
    }
    <!-- Just show percentage in compact mode -->
    @if (compact && isProcessing && !hasError) {
      <span class="progress-text">{{ progress }}%</span>
    }

    @if (canCancel) {
      <button
        mat-icon-button
        class="cancel-button"
        (click)="onCancel($event)"
        [disabled]="isCancelling"
        matTooltip="Cancel processing"
        aria-label="Cancel source processing"
      >
        @if (isCancelling) {
          <mat-progress-spinner [diameter]="16" mode="indeterminate"></mat-progress-spinner>
        } @else {
          <mat-icon>stop_circle</mat-icon>
        }
      </button>
    }

    <!-- Error State with Retry -->
    @if (hasError) {
      <div class="error-wrapper">
        <!-- <span class="error-message">{{ errorMessage | slice: 0 : 30 }}{{ errorMessage.length > 30 ? '...' : '' }}</span> -->
        <button mat-icon-button class="retry-button" (click)="onRetry($event)" [disabled]="isRetrying" matTooltip="Retry processing">
          @if (isRetrying) {
            <mat-progress-spinner [diameter]="16" mode="indeterminate"></mat-progress-spinner>
          } @else {
            <mat-icon>refresh</mat-icon>
          }
        </button>
      </div>
    }

    <!-- Retry count indicator -->
    @if (status.retryCount && status.retryCount > 0) {
      <span class="retry-count" [matTooltip]="'Retry attempts: ' + status.retryCount">
        ({{ status.retryCount }})
      </span>
    }
  </div>
}
